var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 1.66675H5.83335C3.53335 1.66675 1.66669 3.52508 1.66669 5.81675V10.8001V11.6334C1.66669 13.9251 3.53335 15.7834 5.83335 15.7834H7.08335C7.30835 15.7834 7.60835 15.9334 7.75002 16.1167L9.00002 17.7751C9.55002 18.5084 10.45 18.5084 11 17.7751L12.25 16.1167C12.4084 15.9084 12.6584 15.7834 12.9167 15.7834H14.1667C16.4667 15.7834 18.3334 13.9251 18.3334 11.6334V5.81675C18.3334 3.52508 16.4667 1.66675 14.1667 1.66675ZM10.8334 11.4584H5.83335C5.49169 11.4584 5.20835 11.1751 5.20835 10.8334C5.20835 10.4917 5.49169 10.2084 5.83335 10.2084H10.8334C11.175 10.2084 11.4584 10.4917 11.4584 10.8334C11.4584 11.1751 11.175 11.4584 10.8334 11.4584ZM14.1667 7.29175H5.83335C5.49169 7.29175 5.20835 7.00842 5.20835 6.66675C5.20835 6.32508 5.49169 6.04175 5.83335 6.04175H14.1667C14.5084 6.04175 14.7917 6.32508 14.7917 6.66675C14.7917 7.00842 14.5084 7.29175 14.1667 7.29175Z",
    fill: "#3C81FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerComment);
export default __webpack_public_path__ + "static/media/customer-comment.4313a976569832b191038a4bd710cb33.svg";
export { ForwardRef as ReactComponent };